import { Box, Typography } from "@mui/material";
import { color, Grid } from "@mui/system";
import LandingLayout from "components/landing/LandingLayout";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const TermOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();
  return (
    <LandingLayout>
      <Box sx={{ padding: "6.25vw 19.375vw" }}>
        <Typography
          fontWeight={800}
          sx={{ fontSize: "60px", lineHeight: "72px", textAlign: "center" }}
        >
          Terms of service
        </Typography>
        <h2 style={{ marginTop: "3rem" }}>1. Information We Collect</h2>
        <p>
          <span data-contrast="auto">
            Our commercial trading terms are provided to customers separately,
            but some important points for you to know about this website and
            interacting with us before you become a customer are set out below:
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <ul>
          <li
            data-leveltext=""
            data-font="Symbol"
            data-listid="1"
            data-list-defn-props='{"335552541":1,"335559685":720,"335559991":360,"469769226":"Symbol","469769242":[8226],"469777803":"left","469777804":"","469777815":"multilevel"}'
            data-aria-posinset="1"
            data-aria-level="1"
          >
            <span data-contrast="auto">
              we will handle your personal information in accordance with our
              privacy policy, available at 
            </span>
            <a href="#" onClick={() => navigate("/privacy-policy")}>
              https://ezifin.com/privacy-policy
            </a>
            <span data-ccp-props="{}">&nbsp;</span>
          </li>
        </ul>
        <ul>
          <li
            data-leveltext=""
            data-font="Symbol"
            data-listid="1"
            data-list-defn-props='{"335552541":1,"335559685":720,"335559991":360,"469769226":"Symbol","469769242":[8226],"469777803":"left","469777804":"","469777815":"multilevel"}'
            data-aria-posinset="2"
            data-aria-level="1"
          >
            <span data-contrast="auto">
              browsing this website is at your own risk and its contents is for
              information only and does not constitute any form of advice or
              recommendations. We make no representations to you and you should
              obtain your own advice from third parties regarding the contents
              and products;
            </span>
            <span data-ccp-props="{}">&nbsp;</span>
          </li>
        </ul>
        <ul>
          <li
            data-leveltext=""
            data-font="Symbol"
            data-listid="1"
            data-list-defn-props='{"335552541":1,"335559685":720,"335559991":360,"469769226":"Symbol","469769242":[8226],"469777803":"left","469777804":"","469777815":"multilevel"}'
            data-aria-posinset="3"
            data-aria-level="1"
          >
            <span data-contrast="auto">
              where any third party is identified or referred to, any such
              identification or reference is not to be taken as any form of
              endorsement and/or recommendation by us of such third party;
            </span>
            <span data-ccp-props="{}">&nbsp;</span>
          </li>
        </ul>
        <ul>
          <li
            data-leveltext=""
            data-font="Symbol"
            data-listid="1"
            data-list-defn-props='{"335552541":1,"335559685":720,"335559991":360,"469769226":"Symbol","469769242":[8226],"469777803":"left","469777804":"","469777815":"multilevel"}'
            data-aria-posinset="4"
            data-aria-level="1"
          >
            <span data-contrast="auto">
              we may receive a service or other fee from&nbsp; certain third
              party partners identified on this website; and
            </span>
            <span data-ccp-props="{}">&nbsp;</span>
          </li>
        </ul>
        <ul>
          <li
            data-leveltext=""
            data-font="Symbol"
            data-listid="1"
            data-list-defn-props='{"335552541":1,"335559685":720,"335559991":360,"469769226":"Symbol","469769242":[8226],"469777803":"left","469777804":"","469777815":"multilevel"}'
            data-aria-posinset="5"
            data-aria-level="1"
          >
            <span data-contrast="auto">
              we may receive a benefit (which may include a referral fee or a
              commission) should you visit certain third-party websites via a
              link made available by us.
            </span>
            <span data-ccp-props="{}">&nbsp;</span>
          </li>
        </ul>
        <p>
          <span data-contrast="auto">
            Nothing in these terms limit your rights under Australian law and in
            particular the Australian Consumer Law.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>

        <h2>2. Introduction</h2>

        <p>
          <span data-contrast="auto">
            <b>2.1</b> These terms and conditions (
          </span>
          <strong>
            <span data-contrast="auto">Terms</span>
          </strong>
          <span data-contrast="auto">
            ) are entered into between Ezi Financial Services Pty Ltd ACN 628
            254 455 (
          </span>
          <strong>
            <span data-contrast="auto">we</span>
          </strong>
          <span data-contrast="auto">, </span>
          <strong>
            <span data-contrast="auto">us</span>
          </strong>
          <span data-contrast="auto"> or </span>
          <strong>
            <span data-contrast="auto">our</span>
          </strong>
          <span data-contrast="auto">) and you, together the </span>
          <strong>
            <span data-contrast="auto">Parties</span>
          </strong>
          <span data-contrast="auto"> and each a </span>
          <strong>
            <span data-contrast="auto">Party</span>
          </strong>
          <span data-contrast="auto">.</span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>2.2</b> We provide lending and finance services, under specified
            conditions and terms (&ldquo;Services&rdquo;).
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>2.3</b> In these Terms, 
          </span>
          <strong>
            <span data-contrast="auto">you </span>
          </strong>
          <span data-contrast="auto">
            means (as applicable) any person browsing to this website for any
            reason, and/or each individual accessing or using our Services.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>2.4</b> If you are using this website and/or accessing our
            Services on behalf of your employer or a business entity, you, in
            your individual capacity, represent and warrant that you are
            authorised to act on behalf of your employer or the business entity
            and to bind the entity and the entity&rsquo;s personnel to these
            Terms.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <h2>3. Acceptance and Platform Licence</h2>
        <p>
          <span data-contrast="auto">
            <b>3.1</b> You accept these Terms by remaining on this page and/or
            continuing to browse this website.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>3.2</b> You must be at least 18 years old to access our Services.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>3.3</b> We may amend these Terms at any time. Where you have
            registered with us we will provide written notice to you (
          </span>
          <strong>
            <span data-contrast="auto">Notice of Variation</span>
          </strong>
          <span data-contrast="auto">
            ). The variation of these Terms will be taken to be effective 30
            days after the date of the Notice of Variation. By clicking &ldquo;I
            accept&rdquo; or continuing to use after receipt of the Notice of
            Variation,{" "}
          </span>
          <span data-contrast="auto">
            you will be deemed to have agreed to the amended Terms. If you do
            not agree to the amendment, you may cancel your registration by
            giving written notice to us. Any cancellation of registration by you
            will not interfere with or otherwise affect any contract or other
            agreement you have entered into with us
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>3.4</b> We may use, or our Services may be affected by, third
            party APIs. Any such third party APIs will be subject to their terms
            of use. If there is an inconsistency between our terms and the third
            party terms, then our terms will prevail to the extent of the
            inconsistency.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>3.5</b> Subject to your compliance with these Terms, we grant you
            a personal, non-exclusive, revocable, worldwide, non-transferable
            licence to use our website, and any associated platform
            (&ldquo;Platforms&rdquo;), in accordance with these Terms. All other
            uses are prohibited without our prior written consent.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>3.6</b> You agree to use the Platforms in good faith and for a
            proper purpose, and when using the Platforms (which includes any one
            or more of them), you must not do or attempt to do anything that is
            unlawful or inappropriate, including:
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <ul>
          <span data-contrast="auto">
            (a) anything that would constitute a breach of an individual&rsquo;s
            privacy (including uploading private or personal information without
            an individual&rsquo;s consent) or any other legal rights;
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">
            (b) using the Platforms to defame, harass, threaten, menace or
            offend any person;
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">
            (c) using the Platforms for unlawful purposes;
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">
            (d) interfering with any user of the Platforms;
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">
            (e) tampering with or modifying the Platforms (including by
            transmitting viruses and using trojan horses);
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">
            (f) using the Platforms to send unsolicited electronic messages;
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">
            (g) using data mining, robots, screen scraping or similar data
            gathering and extraction tools on the Platforms; or
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">
            (h) facilitating or assisting a third party to do any of the above
            acts.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <p>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <h2>4. Accounts</h2>
        <p>
          <span data-contrast="auto">
            <b>4.1</b> You may need to register on the Platform and create an
            account (
          </span>
          <strong>
            <span data-contrast="auto">Account</span>
          </strong>
          <span data-contrast="auto">
            ) to access the Platform&rsquo;s features.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>4.2</b> You may only have 1 Account on the Platform.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>4.3</b> You must provide basic information when registering for
            an Account including your contact name, email address and phone
            number.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>4.4</b> Once you have registered an Account, your Account
            information will be used to create a profile which you may then
            curate.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>4.5</b> All personal information you provide to us will be
            treated in accordance with our Privacy Policy.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>4.6</b> You agree to provide and maintain up to date information
            in your Account and to not share your Account details with any other
            person. Your Account is personal and you must not transfer it to
            others.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>4.7</b> You are responsible for keeping your Account details
            confidential and you will be liable for all activity on your
            Account. You agree to immediately notify us of any unauthorised use
            of your Account.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>4.8</b> We may make access to and use of certain parts of the
            Platform subject to conditions or requirements, including identity
            verification, cancellation history, and quality of services.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <h2>5. Communication</h2>
        <p>
          <span data-contrast="auto">
            Where you have registered with us we may contact you via the
            Platforms using in-Account notifications, or via off-Platform
            communication channels, such as text message or email.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <h2>6. Intellectual Property</h2>
        <p>
          <span data-contrast="auto">
            <b>6.1</b> All intellectual property (including copyright)
            developed, adapted, modified or created by us or our personnel
            (including in connection with the Terms, any content on the
            Platforms (excluding that of any third party), and documents
            developed by us including but not limited to these Terms) (
          </span>
          <strong>
            <span data-contrast="auto">Our Intellectual Property</span>
          </strong>
          <span data-contrast="auto">
            ) will at all times vest, or remain vested, in us.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>6.2</b> We hereby grant to you a limited, personal licence to use
            Our Intellectual Property solely for the purposes of browsing this
            website.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>6.3</b> You must not, without our prior written consent:
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <ul>
          <span data-contrast="auto">
            (a) copy, in whole or in part, any of Our Intellectual Property;
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">
            (b) reproduce, retransmit, distribute, disseminate, sell, publish,
            broadcast or circulate any of Our Intellectual Property to any third
            party;
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">
            (c) use for an improper purpose any of Our Intellectual Property; or
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">
            (d) breach any intellectual property rights connected with the
            Platforms, including (without limitation) altering or modifying any
            of Our Intellectual Property; causing any of Our Intellectual
            Property to be framed or embedded in another website; or creating
            derivative works from any of Our Intellectual Property.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <p>
          <span data-contrast="auto">
            <b>6.4</b> You agree that any revenue or proceeds obtained by you or
            by any other person as a result of a breach of this clause and for 5
            years from the breach is a fair partial compensation to us and is
            immediately and irrevocably payable to us irrespective of us
            exercising our rights or not in assessing for further damages.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>6.5</b> This clause will survive the termination or expiry of
            these Terms.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <h2>7. Content You Upload</h2>
        <p>
          <span data-contrast="auto">
            <b>7.1</b> You may be permitted to post, upload, publish, submit or
            transmit relevant information and content (
          </span>
          <strong>
            <span data-contrast="auto">User Content</span>
          </strong>
          <span data-contrast="auto">
            ) to this website and/or the Platforms. We may run campaigns via the
            Platform and via social media that encourage you to post User
            Content on social media using specific hashtags (#) (
          </span>
          <strong>
            <span data-contrast="auto">Tag</span>
          </strong>
          <span data-contrast="auto">).</span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>7.2</b> If you make any User Content available on or through the
            Platforms, including on social media using a Tag, you grant to us a
            worldwide, irrevocable, perpetual, non-exclusive, transferable,
            royalty-free licence to use the User Content, with the right to use,
            view, copy, adapt, modify, distribute, license, transfer,
            communicate, publicly display, publicly perform, feed machine
            learning or otherwise contribute to AI engines, transmit, stream,
            broadcast, access, or otherwise exploit such User Content on,
            through or by means of the Platform and our social media platforms.
            You may request that any of your User Content is removed from the
            front-end of the Platform or social media by sending us an email to
            the address at the end of these Terms. We will endeavour to action
            any removal requests within a reasonable time.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>7.3</b> You agree that you are solely responsible for all User
            Content that you make available on or through the Platform,
            including on social media using a Tag. You represent and warrant
            that:
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <ul>
          <span data-contrast="auto">
            (a) you are either the sole and exclusive owner of all User Content
            or you have all rights, licences, consents and releases that are
            necessary to grant to us the rights in such User Content (as
            contemplated by these Terms); and
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">
            (b) neither the User Content nor the posting, uploading,
            publication, submission or transmission of the User Content or our
            use of the User Content on, through or by means of our Platform
            (including on social media) will infringe, misappropriate or violate
            a third party&rsquo;s intellectual property rights, or rights of
            publicity or privacy, or result in the violation of any applicable
            law or regulation.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <p>
          <span data-contrast="auto">
            <b>7.4</b> We do not endorse or approve, and are not responsible
            for, any User Content not provided by us. We may, at any time (at
            our sole discretion), remove any User Content.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>7.5</b> This clause will survive the termination or expiry of
            these Terms.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <h2>8. Warranties</h2>
        <p>
          <span data-contrast="auto">
            You represent, warrant and agree that:
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <ul>
          <span data-contrast="auto">(a)</span>{" "}
          <span data-contrast="auto">
            you will not use our Platforms, including Our Intellectual Property,
            in any way that competes with our business;
          </span>
          <span data-ccp-props='{"335559685":851,"335559991":567}'>&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">(b)</span>{" "}
          <span data-contrast="auto">
            there are no legal restrictions preventing you from entering into
            and/or complying with these Terms;
          </span>
          <span data-ccp-props='{"335559685":851,"335559991":567}'>&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">(c)</span>{" "}
          <span data-contrast="auto">
            all information and documentation that you provide to us in
            connection with these Terms or requesting our Services is true,
            correct and complete;
          </span>
          <span data-ccp-props='{"335559685":851,"335559991":567}'>&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">(d)</span>{" "}
          <span data-contrast="auto">
            you are responsible for complying with all laws, rules and
            regulations which apply to providing the Digital Products in your
            Listings; and
          </span>
          <span data-ccp-props='{"335559685":851,"335559991":567}'>&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">(e)</span>{" "}
          <span data-contrast="auto">
            you are appropriately qualified, and have any required licences,
            approvals, skills, knowledge or training, to provide the Digital
            Products.
          </span>
          <span data-ccp-props='{"335559685":851,"335559991":567}'>&nbsp;</span>
        </ul>
        <h2>9. Australian Consumer Law</h2>
        <p>
          <span data-contrast="auto">
            <b>9.1</b> Certain legislation, including the Australian Consumer
            Law (
          </span>
          <strong>
            <span data-contrast="auto">ACL</span>
          </strong>
          <span data-contrast="auto">
            ) in the Competition and Consumer Act 2010 (Cth), and similar
            consumer protection laws and regulations, may confer you with
            rights, warranties, guarantees and remedies relating to the
            provision of the Platform by us to you which cannot be excluded,
            restricted or modified (
          </span>
          <strong>
            <span data-contrast="auto">Consumer Law Rights</span>
          </strong>
          <span data-contrast="auto">).</span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>9.2</b> If the ACL applies to you as a consumer, nothing in these
            Terms excludes your Consumer Law Rights as a consumer under the ACL.
            You agree that our Liability for the Platform provided to an entity
            defined as a consumer under the ACL is governed solely by the ACL
            and these Terms.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>9.3</b> Subject to your Consumer Law Rights, we exclude all
            express and implied warranties, and all material, work and services
            (including the Platform) are provided to you without warranties of
            any kind, either express or implied, whether in statute, at law or
            on any other basis.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>9.4</b> As a Purchaser, the Digital Products provided by a
            Listing Partner may also confer on you certain rights under the ACL.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>9.5</b> This clause will survive the termination or expiry of
            these Terms.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <h2>10. Limitations on liability</h2>
        <p>
          <span data-contrast="auto">
            <b>10.1</b> To the maximum extent permitted by law, we will not be
            liable for, and you waive and release us from and against, any
            Liability caused or contributed to by, arising from or connected
            with any aspect of the Services.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>10.2</b> Despite anything to the contrary, to the maximum extent
            permitted by law:
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <ul>
          <span data-contrast="auto">
            (a) no Party will be liable for Consequential Loss;
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <ul>
          <span data-contrast="auto">
            (b) each Party&rsquo;s liability for any Liability under these Terms
            will be reduced proportionately to the extent the relevant Liability
            was caused or contributed to by the acts or omissions of the other
            Party or any of that Party&rsquo;s personnel, including any failure
            by that party to mitigate its losses; and
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </ul>
        <p>
          <span data-contrast="auto">
            <b>10.3</b> This clause will survive the termination or expiry of
            these Terms.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <h2>11. Termination</h2>
        <p>
          <span data-contrast="auto">
            <b>11.1</b> Your Account may be terminated by you at any time, using
            the &lsquo;cancel Account&rsquo; functionality (or similar) in the
            Account page section of your Account settings. Your cancellation
            will take effect from the date you execute the cancel Account
            function.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">
            <b>11.2</b> We may terminate your Account at any time by giving you
            written notice, without cause.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <h2>12. General</h2>
        <p>
          <strong>
            <span data-contrast="auto">12.1 Assignment:</span>
          </strong>
          <span data-contrast="auto">
             Subject to the below clause, a Party must not assign or deal with
            the whole or any part of its rights or obligations under these Terms
            without the prior written consent of the other Party (such consent
            is not to be unreasonably withheld).
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">12.2 Assignment of Debt:</span>
          </strong>
          <span data-contrast="auto">
             You agree that we may assign or transfer any debt owed by you to
            us, arising under or in connection with these Terms, to a debt
            collector, debt collection agency, or other third party.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">12.3 Confidentiality:</span>
          </strong>
          <span data-contrast="auto">
             Other than where the disclosure is permitted by law, each Party
            agrees not to disclose any confidential information it may access on
            or through the Platforms to a third party, or otherwise misuse such
            confidential information.&nbsp;
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">12.4 Disputes:</span>
          </strong>
          <span data-contrast="auto">
             In relation to a dispute, controversy or claim arising from, or in
            connection with, these Terms, a Party may not commence court
            proceedings relating to a Dispute without first meeting with a
            senior representative of the other Party to seek (in good faith) to
            resolve the Dispute. If the Parties cannot agree how to resolve the
            Dispute at that initial meeting, either Party may refer the matter
            to a mediator. If the Parties cannot agree on who the mediator
            should be, either Party may ask the Law Society of New South Wales
            to appoint a mediator. The mediator will decide the time, place and
            rules for mediation. The Parties agree to attend the mediation in
            good faith, to seek to resolve the Dispute. The costs of the
            mediation will be shared equally between the Parties. Nothing in
            this clause will operate to prevent a Party from seeking urgent
            injunctive or equitable relief from a court of appropriate
            jurisdiction.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">12.5 Entire Terms:</span>
          </strong>
          <span data-contrast="auto">
             Subject to your Consumer Law Rights, these Terms contains the
            entire understanding between the Parties and the Parties with
            respect to browsing and/or using this website, and you agree that no
            representation or statement has been made to, or relied upon by,
            either of the Parties, except as expressly stipulated in these
            Terms, and these Terms supersede all previous discussions,
            communications, negotiations, understandings, representations,
            warranties, commitments and agreements, in respect of its subject
            matter.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">12.6 Force Majeure:</span>
          </strong>
          <span data-contrast="auto">
             Neither Party will be liable for any delay or failure to perform
            their respective obligations under these Terms if such delay or
            failure is caused or contributed to by a Force Majeure Event,
            provided the Party seeking to rely on the benefit of this clause, as
            soon as reasonably practical, notifies the other party in writing
            about the Force Majeure Event and the extent to which it is unable
            to perform its obligations, and uses reasonable endeavours to
            minimise the duration and adverse consequences of the Force Majeure
            Event.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">12.7 Further assurance:</span>
          </strong>
          <span data-contrast="auto">
             Each Party must promptly do all things and execute all further
            instruments necessary to give full force and effect to these Terms
            and their obligations under it.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">12.8 Governing law:</span>
          </strong>
          <span data-contrast="auto">
             These Terms are governed by the laws of New South Wales. Each Party
            irrevocably and unconditionally submits to the exclusive
            jurisdiction of the courts operating in New South Wales and any
            courts entitled to hear appeals from those courts and waives any
            right to object to proceedings being brought in those courts.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">12.9 Notices:</span>
          </strong>
          <span data-contrast="auto">
             Any notice given under these Terms must be in writing addressed to
            us at the details set out below or to you at the details provided in
            your Account. Any notice may be sent by standard post or email, and
            will be deemed to have been served on the expiry of 48 hours in the
            case of post, or at the time of transmission in the case of
            transmission by email.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">12.10 Privacy:</span>
          </strong>
          <span data-contrast="auto">
             Each Party agrees to comply with the legal requirements of the
            Australian Privacy Principles as set out in the 
          </span>
          <em>
            <span data-contrast="auto">Privacy Act 1988 (Cth)</span>
          </em>
          <span data-contrast="auto">
             and any other applicable legislation or privacy guidelines.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">12.11 Relationship of Parties:</span>
          </strong>
          <span data-contrast="auto">
             These Terms are not intended to create a partnership, joint
            venture, employment or agency relationship between the Parties.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">12.13 Severance:</span>
          </strong>
          <span data-contrast="auto">
             If a provision of these Terms is held to be void, invalid, illegal
            or unenforceable, that provision is to be read down as narrowly as
            necessary to allow it to be valid or enforceable, failing which,
            that provision (or that part of that provision) will be severed from
            these Terms without affecting the validity or enforceability of the
            remainder of that provision or the other provisions in these Terms.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">12.14 Third party sites:</span>
          </strong>
          <span data-contrast="auto">
             The Platform may contain links to websites operated by third
            parties. Unless we tell you otherwise, we do not control, endorse
            support and/or approve, and are not responsible for, the content on
            those websites. We recommend that you make your own investigations
            with respect to the suitability of those websites. If you purchase
            goods or services from a third party website linked from this
            Website and/or Platforms, such third party provides the goods and
            services to you, not us. We may receive a benefit (which may include
            a referral fee or a commission) should you visit certain third-party
            websites via a link on the Platform (
          </span>
          <strong>
            <span data-contrast="auto">Affiliate Link</span>
          </strong>
          <span data-contrast="auto">
            ) or for featuring certain products or services on the Platform. We
            will make it clear by notice to you which (if any) products or
            services we receive a benefit to feature on the Platform, or which
            (if any) third party links are Affiliate Links.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <h2>13. Definitions</h2>
        <p>
          <strong>
            <span data-contrast="auto">13.1 Consequential Loss</span>
          </strong>
          <span data-contrast="auto">
             means, whether under statute, contract, equity, tort (including
            negligence), indemnity or otherwise; any loss or damage that cannot
            be considered to arise according to the usual course of things from
            the relevant breach, act or omission, whether or not such loss or
            damage may reasonably be supposed to have been in the contemplation
            of the Parties at the time they entered into these Terms as the
            probable results of the relevant breach, act or omission, and/or,
            any real or anticipated loss of profit, loss of benefit, loss of
            revenue, loss of business, loss of goodwill, loss of opportunity,
            loss of savings, loss of reputation, loss of use and/or loss or
            corruption of data. The Parties agree that your obligation to pay us
            the Fee under these Terms will not constitute &ldquo;Consequential
            Loss&rdquo;.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">13.2 Force Majeure Event</span>
          </strong>
          <span data-contrast="auto">
             means any event or circumstance which is beyond a Party&rsquo;s
            reasonable control.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">13.3 Intellectual Property</span>
          </strong>
          <span data-contrast="auto">
             means any and all existing and future rights throughout the world
            conferred by statute, common law, equity or any corresponding law in
            relation to any copyright, designs, patents or trade marks, domain
            names, know-how, inventions, processes, trade secrets or
            confidential information, circuit layouts, software, computer
            programs, databases or source codes, including any application, or
            right to apply, for registration of, and any improvements,
            enhancements or modifications of, the foregoing, whether or not
            registered or registrable.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">13.4 Liability</span>
          </strong>
          <span data-contrast="auto">
             means any expense, cost, liability, loss, damage, claim, notice,
            entitlement, investigation, demand, proceeding or judgment (whether
            under statute, contract, equity, tort (including negligence),
            indemnity or otherwise), howsoever arising, whether direct or
            indirect and/or whether present, unascertained, future or contingent
            and whether involving a third party or a party to these Terms or
            otherwise.
          </span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">
              For any questions or notices, please contact us at:
            </span>
          </strong>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <span data-contrast="auto">Ezi Financial Services Pty Ltd</span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">Email:</span>
          </strong>
          <span data-contrast="auto"> </span>
          <a href="mailto:support@ezifin.com">
            <span data-contrast="none">
              <span data-ccp-charstyle="Hyperlink">support@ezifin.com</span>
            </span>
          </a>{" "}
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">Portal: </span>
          </strong>
          <a href="https://ezifin.com/">
            <strong>
              <span data-contrast="none">
                <span data-ccp-charstyle="Hyperlink">https://ezifin.com</span>
              </span>
            </strong>
          </a>
          <strong>
            <span data-contrast="auto">&nbsp;</span>
          </strong>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">Last update:</span>
          </strong>
          <span data-contrast="auto"> 22 September 2025</span>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
        <p>
          <strong>
            <span data-contrast="auto">
              Collected data usage and terms of use
            </span>
          </strong>
          <span data-ccp-props="{}">&nbsp;</span>
        </p>
      </Box>
    </LandingLayout>
  );
};

export default TermOfService;
